import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoPhone = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Phone</title>
    <path
      d="M28.238 21.59v3.385a2.252 2.252 0 0 1-1.536 2.146c-.299.101-.615.138-.928.11a22.398 22.398 0 0 1-9.755-3.463A22.02 22.02 0 0 1 9.238 17a22.297 22.297 0 0 1-3.47-9.78 2.252 2.252 0 0 1 1.338-2.268c.287-.126.597-.192.91-.192h3.392a2.263 2.263 0 0 1 2.26 1.94c.144 1.083.409 2.147.792 3.17a2.252 2.252 0 0 1-.51 2.38l-1.435 1.433a18.068 18.068 0 0 0 6.782 6.768l1.436-1.432a2.262 2.262 0 0 1 2.385-.508c1.025.382 2.09.647 3.176.79a2.262 2.262 0 0 1 1.944 2.29Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoPhone;
